import { render, staticRenderFns } from "./WarningReportDialog.vue?vue&type=template&id=0d243e4c"
import script from "./WarningReportDialog.vue?vue&type=script&lang=js"
export * from "./WarningReportDialog.vue?vue&type=script&lang=js"
import style0 from "./WarningReportDialog.vue?vue&type=style&index=0&id=0d243e4c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports